import React, { forwardRef } from "react";
import cx from "clsx";
import classesResponsive from "../../../Shared/scss/Responsive.module.scss";
import SectionTitle from "../../../Shared/SectionTitle";
import styles from "./scss/ThirdSection.module.scss";
import { reviews } from "./Reviews.utils";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ReviewsCarousel from "./components/ReviewsCarousel";

const ThirdSection = forwardRef((_props, ref) => {
  return (
    <div className={styles.thirdSection} ref={ref}>
      <SectionTitle>Părerile Pacienților</SectionTitle>
      <div
        className={cx(
          styles.reviewsContainer,
          classesResponsive.paddingLeftRight
        )}
      >
        <ReviewsCarousel reviews={reviews} />
      </div>
    </div>
  );
});

export default ThirdSection;
